export const getAssessmentOptions = (): Array<{ label: string; value: string }> => {
  return Array.from({ length: 13 }).map((_, idx) => ({
    label: idx === 0 ? "Main Assessment" : `Follow up Assessment ${idx}`,
    value: String(idx),
  }));
};

export const validateMeetingLink = (link: string): boolean => {
  if (!link.trim()) {
    return false;
  }
  // Validate Google Meet or Zoom links
  const googleMeetPattern =
    /^https:\/\/(meet\.google\.com|meet\.google\.com\/[a-z]{3}-[a-z]{4}-[a-z]{3})/i;
  const zoomPattern = /^https:\/\/(zoom\.us|us\d+web\.zoom\.us)\/j\/\d+/i;
  return googleMeetPattern.test(link) || zoomPattern.test(link);
};

export const getStatusLabel = (status: string) => {
  return status.charAt(0).toUpperCase() + status.slice(1);
};

const assessmentHelpers = {
  getAssessmentOptions,
  validateMeetingLink,
  getStatusLabel,
};

export default assessmentHelpers;

